export const PLACEHOLDER_EMPTY_WORKFLOW_ID = '__EMPTY__';
export const NEW_WORKFLOW_ID = 'new';
export const DEFAULT_NODETYPE_VERSION = 1;
export const DEFAULT_NEW_WORKFLOW_NAME = 'My workflow';
export const MIN_WORKFLOW_NAME_LENGTH = 1;
export const MAX_WORKFLOW_NAME_LENGTH = 128;
export const DUPLICATE_POSTFFIX = ' copy';
export const NODE_OUTPUT_DEFAULT_KEY = '_NODE_OUTPUT_DEFAULT_KEY_';
export const DEFAULT_WORKFLOW_PAGE_SIZE = 50;
export const WORKFLOWS_DRAFT_PUBLISH_ENABLED_FLAG = 'WORKFLOWS_DRAFT_PUBLISH_ENABLED';

// TODO: We need to do a proper cleanup of the old functionality (non-draft-publish mode)
// and then drop this constant
export const IS_DRAFT_PUBLISH_ENABLED = true;
